import React, { useState } from 'react';
import { Check, Plus, X } from 'lucide-react';
import { MAX_COLORES, PALETA, PCT_REFERIDO, TIPOS_BENEFICIO, hexValido, slugPareja, textoBeneficio, urlCompartirBoda } from '../bodasUtils';
import BuscadorCliente from './BuscadorCliente';
import FotoCompartir from './FotoCompartir';
import { CampoSelect, CampoTexto } from './comunes';

export const PasoPareja = ({ f, set, cliente, setCliente, vista, setFoto }) => (
  <div className="space-y-4">
    <div className="grid gap-4 sm:grid-cols-2">
      <CampoTexto label="Nombre de la primera persona *" value={f.persona_a} onChange={set('persona_a')} placeholder="Ej.: Andrés" testId="boda-persona-a" />
      <CampoTexto label="Nombre de la segunda persona *" value={f.persona_b} onChange={set('persona_b')} placeholder="Ej.: Valentina" testId="boda-persona-b" />
    </div>
    {f.persona_a && f.persona_b && <p className="text-xs text-slate-500">Enlace sugerido: <span className="break-all font-mono">{urlCompartirBoda(slugPareja(f.persona_a, f.persona_b))}</span></p>}
    <FotoCompartir vista={vista} setFoto={setFoto} encuadre={f.foto_encuadre} setEncuadre={set('foto_encuadre')} />
    <BuscadorCliente seleccionado={cliente} onSeleccionar={setCliente} label="Cliente (novio o novia) que recibe los puntos"
      ayuda="Por cada invitado que compre, este cliente recibe 200 Puntos JPM. Si no lo eliges, la página funciona pero no suma puntos." testId="boda-cliente" />
    <CampoTexto label="Notas internas (no se muestran)" value={f.observaciones_internas} onChange={set('observaciones_internas')} multiline testId="boda-notas" />
  </div>
);

export const PasoEvento = ({ f, set }) => (
  <div className="space-y-4">
    <CampoTexto label="Fecha de la boda" value={f.fecha_texto} onChange={set('fecha_texto')} placeholder="Ej.: Sábado 14 de marzo de 2027" testId="boda-fecha" />
    <CampoTexto label="Código de vestuario" value={f.codigo_vestuario} onChange={set('codigo_vestuario')} placeholder="Ej.: Etiqueta rigurosa" testId="boda-vestuario" />
    <CampoTexto label="Indicaciones de vestuario" value={f.indicaciones_vestuario} onChange={set('indicaciones_vestuario')} multiline placeholder="Ej.: Traje oscuro y corbata" testId="boda-indicaciones" />
  </div>
);

const ColorPropio = ({ onAgregar }) => {
  const [c, setC] = useState({ nombre: '', hex: '#' });
  const valido = c.nombre.trim() && hexValido(c.hex);
  return (
    <div className="grid gap-2 sm:grid-cols-[1fr_9rem_auto]">
      <CampoTexto label="Otro color: nombre" value={c.nombre} onChange={v => setC(p => ({ ...p, nombre: v }))} placeholder="Ej.: Rosa palo" testId="boda-color-nombre" />
      <CampoTexto label="Código HEX" value={c.hex} onChange={v => setC(p => ({ ...p, hex: v }))} placeholder="#D8A7A7" testId="boda-color-hex" />
      <button type="button" disabled={!valido} onClick={() => { onAgregar({ nombre: c.nombre.trim(), hex: c.hex.trim() }); setC({ nombre: '', hex: '#' }); }}
        className="inline-flex items-center justify-center gap-1 self-end rounded-lg bg-slate-800 px-3 py-2.5 text-sm font-medium text-white disabled:opacity-40" data-testid="boda-color-agregar"><Plus className="h-4 w-4" />Agregar</button>
    </div>
  );
};

export const PasoColores = ({ f, setColores }) => {
  const elegido = (c) => f.colores.some(x => x.hex.toUpperCase() === c.hex.toUpperCase());
  const alternar = (c) => setColores(elegido(c) ? f.colores.filter(x => x.hex.toUpperCase() !== c.hex.toUpperCase()) : f.colores.length < MAX_COLORES ? [...f.colores, c] : f.colores);
  return (
    <div className="space-y-5">
      <p className="text-sm text-slate-600">Colores que la pareja reserva y los invitados deben evitar (máximo {MAX_COLORES}). Opcional.</p>
      <div className="flex flex-wrap gap-2">
        {PALETA.map(c => (
          <button key={c.hex} type="button" onClick={() => alternar(c)} data-testid={`boda-color-${c.hex.slice(1)}`}
            className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors ${elegido(c) ? 'border-slate-800 bg-slate-800 text-white' : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'}`}>
            <span className="h-4 w-4 rounded-full border border-black/10" style={{ background: c.hex }} />{c.nombre}{elegido(c) && <Check className="h-3.5 w-3.5" />}
          </button>
        ))}
      </div>
      {f.colores.filter(c => !PALETA.some(p => p.hex.toUpperCase() === c.hex.toUpperCase())).map(c => (
        <span key={c.hex} className="mr-2 inline-flex items-center gap-2 rounded-full border border-slate-800 bg-slate-800 px-3 py-1.5 text-sm text-white">
          <span className="h-4 w-4 rounded-full" style={{ background: c.hex }} />{c.nombre}
          <button type="button" onClick={() => alternar(c)} aria-label={`Quitar ${c.nombre}`}><X className="h-3.5 w-3.5" /></button>
        </span>
      ))}
      {f.colores.length < MAX_COLORES && <ColorPropio onAgregar={c => !elegido(c) && setColores([...f.colores, c])} />}
    </div>
  );
};

export const PasoBeneficio = ({ f, set }) => (
  <div className="space-y-4">
    <div className="rounded-lg bg-emerald-50 p-3 text-sm text-emerald-900">Por defecto los invitados reciben <strong>{PCT_REFERIDO}% de descuento</strong>, que se carga solo en su primera cotización.</div>
    <div className="grid gap-4 sm:grid-cols-2">
      <CampoSelect label="Tipo de beneficio" value={f.beneficio_tipo} onChange={set('beneficio_tipo')} opciones={TIPOS_BENEFICIO} testId="boda-beneficio-tipo" />
      <CampoTexto label={f.beneficio_tipo === 'porcentaje' ? 'Porcentaje (número)' : 'Beneficio'} value={f.beneficio_valor} onChange={set('beneficio_valor')} testId="boda-beneficio-valor" />
    </div>
    <CampoTexto label="En qué aplica" value={f.beneficio_aplica} onChange={set('beneficio_aplica')} placeholder="Ej.: En trajes a la medida para la boda" testId="boda-beneficio-aplica" />
    <CampoTexto label="Condiciones" value={f.beneficio_condiciones} onChange={set('beneficio_condiciones')} multiline testId="boda-beneficio-condiciones" />
    <CampoTexto label="Vigencia" value={f.beneficio_vigencia} onChange={set('beneficio_vigencia')} placeholder="Ej.: Hasta un mes antes de la boda" testId="boda-beneficio-vigencia" />
  </div>
);

const Dato = ({ k, v }) => <div className="flex justify-between gap-4 border-b border-slate-100 py-2 text-sm"><dt className="text-slate-500">{k}</dt><dd className="text-right font-medium text-slate-800">{v || '—'}</dd></div>;

export const PasoRevision = ({ f, cliente, foto }) => (
  <dl data-testid="boda-revision">
    <Dato k="Pareja" v={`${f.persona_a} & ${f.persona_b}`} />
    <Dato k="Cliente que recibe puntos" v={cliente?.nombre || 'Sin cliente'} />
    <Dato k="Fecha" v={f.fecha_texto} />
    <Dato k="Vestuario" v={f.codigo_vestuario} />
    <Dato k="Colores reservados" v={f.colores.map(c => c.nombre).join(', ')} />
    <Dato k="Beneficio" v={textoBeneficio(f.beneficio_tipo, f.beneficio_valor)} />
    <Dato k="Foto en la invitación" v={foto.archivo || (foto.url && !foto.quitar) ? 'Foto de la pareja con marco' : 'Sin foto'} />
    <Dato k="Imagen al compartir" v={foto.archivo || (foto.url && !foto.quitar) ? 'Foto de la pareja' : 'Logo del Atelier'} />
  </dl>
);
